import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1 text-xs text-foreground-500">
      {items.map((c, i) => (
        <span key={i} className="flex items-center gap-1">
          {i > 0 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          {c.to ? (
            <Link to={c.to} className="transition-colors hover:text-primary-600">
              {c.label}
            </Link>
          ) : (
            <span className="text-foreground-700">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}